// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconHome } from '@tabler/icons';

const icons = {
    IconHome
};

// ==============================|| MENU ITEMS - SAVINGS ||============================== //

const savings = {
    id: 'savings',
    title: <FormattedMessage id="savings" />,
    icon: icons.IconHome,
    type: 'group',
    url: 'savings',
    roles: ['employee']
};

export default savings;
